import React from "react";

const Select = (props) => {
  const {
    data,
    value,
    onChange,
    textProperty,
    valueProperty,
    label,
    name,
    search,
    onClick,
  } = props;

  const handleOnclick = () => {
    onClick(true);
  };

  return (
    <div className="from-group">
      {label && <label htmlFor={name}>{label} </label>}
      <div className="input-group">
        <div className="col-lg-10 p-0">
          <select
            className="form-select "
            id="sel1"
            value={value}
            onChange={onChange}
          >
            {data.map((item) => (
              <option
                key={item[valueProperty]}
                value={item[valueProperty]}
                textname={item[textProperty]}
              >
                {item[textProperty]}
              </option>
            ))}
          </select>
        </div>

        {search && (
          <div className="col-lg-2 p-0">
            <button
              type="button"
              id="show-contact-modal-button"
              className="btn btn-primary"
              onClick={handleOnclick}
            >
              {search}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
Select.defaultProps = {
  textProperty: "name",
  valueProperty: "_id",
};
export default Select;
